export default {
  read: { name: 'Read', value: 1 },
  write: { name: 'Write', value: 2 },
};
